const VECTOR_MINERALES = [
    {
        name: "Comp_RX",
        value: null,
        unit: "%",
    },
    {
        name: "Comp_RX_As",
        value: null,
        unit: "%",
    },
    {
        name: "BORNITA",
        value: null,
        unit: "%",
    },
    {
        name: "CALCOSINA",
        value: null,
        unit: "%",
    },
    {
        name: "COVELINA",
        value: null,
        unit: "%",
    },
    {
        name: "CALCOPIRITA",
        value: null,
        unit: "%",
    },
    {
        name: "ENARGITA",
        value: null,
        unit: "%",
    },
    {
        name: "PIRITA",
        value: null,
        unit: "%",
    },
    {
        name: "MOLIBDENITA",
        value: null,
        unit: "%",
    },
    {
        name: "ESFALERITA",
        value: null,
        unit: "%",
    },
    {
        name: "TEN_TETR",
        value: null,
        unit: "%",
    },
    {
        name: "GANGAS",
        value: null,
        unit: "%",
    },
    {
        name: "Humedad_Prom",
        value: null,
        unit: "%",
    },
    {
        name: "Cu",
        value: null,
        unit: "%",
    },
    {
        name: "S",
        value: null,
        unit: "%",
    },
    {
        name: "Fe",
        value: null,
        unit: "%",
    },
    {
        name: "As",
        value: null,
        unit: "%",
    },
    {
        name: "Zn",
        value: null,
        unit: "%",
    },
    {
        name: "SiO2",
        value: null,
        unit: "%",
    },
    {
        name: "Insoluble",
        value: null,
        unit: "%",
    },
    {
        name: "D90",
        value: null,
        unit: "µm",
    },
    {
        name: "D80",
        value: null,
        unit: "µm",
    },
    {
        name: "D50",
        value: null,
        unit: "µm",
    },

    {
        name: "S_Masa150um",
        value: null,
        unit: "%",
    },
    {
        name: "S_Masa212um",
        value: null,
        unit: "%",
    },
    {
        name: "Metodo",
        value: null,
        unit: "",
    }
];

export default VECTOR_MINERALES;
